// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"6efd05e61f6d4d6ebceb","453":"09758544122d92d8b412"}[chunkId] + ".js";
};